/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_Print_PackingInputs */

const vi_order_action_print_packing = /** @type {(inputs: Order_Action_Print_PackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In phiếu đóng gói`)
};

/**

* @param {Order_Action_Print_PackingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_print_packing = /** @type {((inputs?: Order_Action_Print_PackingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_Print_PackingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_print_packing(inputs)
});